import React, { useState, useEffect } from 'react';
import { CHANGELOG } from './changelog';

const STORAGE_KEY = 'agencyos-changelog-dismissed';

// Compared by order rather than equality so that dismissing an entry later withdrawn from the
// changelog still covers everything before it, instead of re-showing the previous entry.
const isLaterVersion = (a: string, b: string): boolean => {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff > 0;
  }
  return false;
};

const ChangeLogToast: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const latest = CHANGELOG[0];

  useEffect(() => {
    if (!latest?.version) return;
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed || isLaterVersion(latest.version, dismissed)) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    if (latest?.version) {
      localStorage.setItem(STORAGE_KEY, latest.version);
    }
  };

  if (!visible || !latest) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '5rem',
      right: '1.5rem',
      zIndex: 9999,
      maxWidth: '360px',
      width: '90vw',
      background: '#0a202e',
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      border: '1px solid rgba(32,203,212,0.3)',
      overflow: 'hidden',
      animation: 'slideUp 0.3s ease-out',
    }}>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div style={{ padding: '1rem 1.25rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
          <span style={{ color: '#20cbd4', fontWeight: 700, fontSize: '0.85rem' }}>
            What's New {latest.version && `(v${latest.version})`}
          </span>
          <button
            onClick={dismiss}
            style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '1.2rem', lineHeight: 1, padding: '0 0.25rem' }}
          >
            &times;
          </button>
        </div>
        <ul style={{ margin: 0, padding: '0 0 0 1.1rem', listStyle: 'disc' }}>
          {latest.items.map((item, i) => (
            <li key={i} style={{ color: '#e0e0e0', fontSize: '0.82rem', lineHeight: 1.5, marginBottom: '0.3rem' }}>{item}</li>
          ))}
        </ul>
        <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={dismiss}
            style={{ background: '#20cbd4', color: '#0a202e', border: 'none', padding: '0.4rem 1rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer' }}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeLogToast;
